import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { Actions } from "../../../Action";
import { expertAnswerQuestion, fetchUsers, shareQuestion } from "../../../API/api";
import { createLink, wrapImgtagWithDiv } from "../../../utils";
import styles from "./BreifingStyle.module.css";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../../../NewComponent/Button/Button";
import Button2 from "../../../NewComponent/Button2/Button2";
import { ModalHeader } from "../../../Constants";
import SwitchComp from "../../../NewComponent/Switch/Switch";

const submitSuccessToast = () => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>
        You have successfully shared the Question.
      </span>
    </>
  );
};

const textStyles1 = {
  fontSize: "18px",
  color: "#2A364A",
  lineHeight: "24px",
  fontWeight: "500",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  textAlign: "left",
  width: "100%",
};

const submitAnswerSuccessToast = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};
export default function BriefingModal() {
  const modalState = useSelector((state) => state.domain);
  const [isLoading, setLoading] = useState(false)
  const isAnsweredByMe = (arr) => {
    let id = ""
    arr?.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        id = obj.answerUuid;
      }
    })

    return id;
  }
  const isAnsweredByMeOrig = (arr) => {
    let id = ""
    arr?.filter(obj => {
      if (obj.expertUuid === userState.geoAttributes.userId) {
        if (obj.origAnswerUuid !== undefined) {
          id = obj.origAnswerUuid;
        }
        else id = obj.answerUuid;

      }
    })

    return id;
  }



  const editorState = useSelector(state => state.editor);
  const userState = useSelector(state => state.user);
  // console.log("status",editorState?.changeAnswerBool)
  // console.log("data", editorState?.data?.published)
  const answerePage = useSelector(state => state.answeredQuestions);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [files, setFiles] = useState([])
  const expertState = useSelector((state) => state.expertOpenData);
  const name = "answeredQuestions";
  let pageState = useSelector((state) => state[name]);
  const { advanceFilterModalToggle, getScrollPositionInExpertOpen, showNoShowConfetti, updatePageNumberExpertOpenTab, recommendData, updateButtonEnableForEditor, ChangePublishButton, CheckEditAnswerBrief } = bindActionCreators(Actions, dispatch)
  const submitAnswer = (publishSubmit) => {
    setDisabled(true)
    setLoading(true)
    ChangePublishButton(true)
    getScrollPositionInExpertOpen(0)
    CheckEditAnswerBrief(false)

    // console.log("expert value",expertState.getScrollPosition)

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let payload = {
      questionUuidStr: editorState.data.questionUuid,
      answer: wrapImgtagWithDiv(editorState.answerText),
      uplodedFiles: editorState.attachments,
      internal: editorState.internalOnly,
      privacy: editorState.isVizKnowledgeBase,
      expiration: Date.parse(editorState.expirationDate),
      agentUuidStr: editorState.data.agenticId,
      status: editorState?.changeAnswerBool ? "edited & published" : "published",
      question: editorState.data.otherLanguageQuestionText === undefined || editorState.data.otherLanguageQuestionText === null ? editorState.questionText : editorState.data.otherLanguageQuestionText
    }
    if (editorState.data.expertRequestUuid !== undefined && editorState.ownRecords) {
      delete payload.questionUuidStr;
      payload.expertRequestUuid = editorState.data.expertRequestUuid;
    }
    updateButtonEnableForEditor(true);
    expertAnswerQuestion(payload, false).then(res => {
      // console.log("res",res)
      if (res === undefined) {
        ChangePublishButton(false)
        setLoading(false)
        advanceFilterModalToggle({ bool: false, value: "" })
        return;
      }

      showNoShowConfetti(true);
      setLoading(false)
      advanceFilterModalToggle({ bool: false, value: "" })
      // getScrollPositionInExpertOpen(null)
      setTimeout(() => {
        showNoShowConfetti(false);
      }, 5000);
      setDisabled(false)

      updatePageNumberExpertOpenTab(0);
      toast.success(submitAnswerSuccessToast('Thanks for answering!\nYou will be notified when your answer is rated.'), {
        position: toast.POSITION.TOP_RIGHT,
      });
      //      isBackClickedOnRecommend(true);
      //  setTimeout(() => {
      //    resetStateForEditor();
      //    isBackClickedOnRecommend(false);
      //  }, 3000);
      recommendData(null);
      navigate(-1);
    })

  }

  return (
    <>
      <Modal
        show={modalState.modalState}
        onHide={() => {
          ChangePublishButton(false)
          // CheckEditAnswerBrief(false)
          advanceFilterModalToggle({ bool: false, value: "" })
        }}
        centered={true}
        size={"lg"}
        backdrop="static"
      // dialogClassName={styles.modalDialog}
      >
        <Modal.Header closeButton>
          <Modal.Title style={ModalHeader.styles}>
            <span className="fa fa-users"></span>
            &nbsp;&nbsp;Ready to publish?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ display: "flex", flexDirection: "column", gap: "5px", textAlign: "left" }}>
            <h1 style={textStyles1}>This action will notify the Seeker that you have reviewed and confirmed the brief.</h1>
            <h1 style={textStyles1}>Publishing will also make this brief and your updates available to all Seekers</h1>
            {/* <h1 style={textStyles1}>Any edits made will apply to both versions.</h1> */}
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "5px" }}>
            {
              !isLoading ? <>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: ' 0px 1px 2px 0px #1018280D',
                    color: '#2A364A',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: " #F6F7F8",
                    marginBottom: '14px',
                    fontWeight: 400,
                    border: " 1px solid #E0E2E6"


                    //  font-weight: 400;    
                  }} onClick={() => {
                    ChangePublishButton(false)
                    advanceFilterModalToggle({ bool: false, value: "" })
                  }
                  }>Cancel</button>&nbsp;
                {/* <button className="rerouteBtn" onClick={() => onClickSubmit()} disabled={expert.length === 0 ? true : false}>Route</button> */}
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    //  marginTop: "15px",
                    //  cursor:expert.length===0?"not-allowed":"pointer",
                    //  cursor:selectedExpert.length  ? "not-allowed" : "pointer",
                    //  opacity:expert.length===0?"0.7":"",
                  }}
                  //    disabled={expert.length === 0 ? true : false}


                  onClick={() => submitAnswer(true)}
                >
                  Publish
                </button>
              </> : <div>
                <button
                  style={{
                    padding: '8px 12px 8px 12px',
                    borderRadius: '6px',
                    fontSize: '14px',
                    lineHeight: '24px',
                    fontWeight: 400,
                    boxShadow: '0px 1px 2px 0px #1018280D',
                    color: '#FFFFFF',
                    border: '1px solid  #fff',
                    height: '40px',
                    minWidth: '88px',
                    background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
                    marginBottom: '14px',
                    marginTop: "15px",
                    cursor: "not-allowed",
                    opacity: "0.7"
                  }} disabled><i className="fa fa-spinner"></i>&nbsp;&nbsp;Submit..</button>
              </div>
            }


          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
